'use strict';

var GridToolbarRuleCustomStrategyListingDirective = function GridToolbarRuleCustomStrategyListingDirective() {
  return {
    restrict: 'E',
    replace: true,
    require: '^rmGridPanel',
    template: require('../templates/grid-toolbar-rule-custom-strategy-listing.html')
  };
};
GridToolbarRuleCustomStrategyListingDirective.$inject = [];
module.exports = GridToolbarRuleCustomStrategyListingDirective;